"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FormValidatorTypes_1 = require("../Enum/FormValidatorTypes");
const QuestionnaireFormValidator_1 = require("../Validator/QuestionnaireFormValidator");
const WidgetError_1 = require("auto-widget-framework/src/Error/WidgetError");
const BaseFormValidator_1 = require("../Validator/BaseFormValidator");
const NullFormValidator_1 = require("../Validator/NullFormValidator");
const MixedFormValidator_1 = require("../Validator/MixedFormValidator");
class FormValidatorFactory {
    constructor(containerAwareFactory) {
        this.containerAwareFactory = containerAwareFactory;
    }
    /**
     * @inheritDoc
     */
    create(type, args) {
        switch (type) {
            case FormValidatorTypes_1.FormValidatorTypes.QUESTIONNAIRE:
                return this.containerAwareFactory.create(QuestionnaireFormValidator_1.default, args.form, args.questionnaire);
            case FormValidatorTypes_1.FormValidatorTypes.BASE:
                return this.containerAwareFactory.create(BaseFormValidator_1.default, args.form, args.config);
            case FormValidatorTypes_1.FormValidatorTypes.NULL:
                return this.containerAwareFactory.create(NullFormValidator_1.default);
            case FormValidatorTypes_1.FormValidatorTypes.MIXED:
                return this.containerAwareFactory.create(MixedFormValidator_1.default, args.form, args.questionnaire, args.config);
            default:
                throw new WidgetError_1.default(`Form validator type "${type}" not found.`);
        }
    }
}
exports.default = FormValidatorFactory;
